import axios from 'axios';
import { getHostTenant } from '@/services/tenantHost';

let api = null;

export function createApi() {
  const isProd = process.env.VUE_APP_MODE_APP === 'production';
  const envBaseUrl = isProd
    ? process.env.VUE_APP_HOST_API_BACKEND_PROD
    : process.env.VUE_APP_HOST_API_BACKEND_DEV;

  api = axios.create({
    baseURL: getHostTenant() ? '/api' : (envBaseUrl || '/api'),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  return api;
}

export function useApi() {
  if (!api) {
    createApi();
  }
  return api;
}
